import {ApplicationForm} from '../../../../../../components/application-form/application-form';
import {useOffice} from '../../../../../../contexts/office/context';
import {useParams, useRouteMatch} from 'react-router-dom';
import {translations} from '../../../../../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {Box} from '@mui/material';
import GenericHeader from '../../../../../../components/generic-header/generic-header';
import {ScreenPaths} from '../../../../../../enums';
import {getLocalizedFieldValue} from '../../../../../../utils/functions/get-localized-field-value';

interface ApplicationDetailsProfessionalCaregiverOfficeScreenProps {
  canWrite: boolean;
}

export default function ApplicationDetailsProfessionalCaregiverOfficeScreen({
  canWrite,
}: ApplicationDetailsProfessionalCaregiverOfficeScreenProps) {
  const officeContext = useOffice();
  const {t} = useTranslation();
  let {entityId, applicationId}: {entityId: string; applicationId: string} = useParams();
  let {url} = useRouteMatch();

  return (
    <>
      <GenericHeader
        isLoading={!officeContext.state.applicationForm}
        titleCrumbs={[
          {
            label: t(translations.office.professional_caregiver.tabs.digital_inclusion),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_DigitalInclusion}`,
          },
          {
            label: t(translations.office.professional_caregiver.tabs.applications),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_DigitalInclusion}${ScreenPaths.ProfessionalCaregiver_DigitalInclusion_Applications}`,
          },
          {
            label: officeContext.state.applicationForm
              ? getLocalizedFieldValue(officeContext.state.applicationForm, 'name')
              : '',
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_DigitalInclusion}${ScreenPaths.ProfessionalCaregiver_DigitalInclusion_Applications}/${applicationId}/details`,
          },
          {
            label: t(translations.application_tabs.tabs.details),
            link: url,
          },
        ]}
        leftColumn={null}
        rightColumn={null}
      />
      <Box className="listing-container">
        <Box className="listing-container-centered">
          <ApplicationForm canWrite={canWrite} />
        </Box>
      </Box>
    </>
  );
}
